import { Button, Input, InputNumber } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { calcLineSubtotal, formatMoney, formatQuantity } from "../../utils/quoteFormat";
import { useTranslation } from "../../i18n";

function QuoteLineItem({ line, currency, onChange, onRemove, canRemove }) {
    const { t } = useTranslation();
    const subtotal = calcLineSubtotal(line.unitPrice, line.quantity);

    return (
        <div className="quote-line-item">
            <div className="quote-line-item__grid">
                <div className="quote-line-item__field quote-line-item__field--name">
                    <label>{t("quote.form.itemName")}</label>
                    <Input
                        value={line.name}
                        placeholder={t("quote.form.itemNamePlaceholder")}
                        onChange={(event) => onChange({ ...line, name: event.target.value })}
                    />
                </div>

                <div className="quote-line-item__field quote-line-item__field--price">
                    <label>{t("quote.form.unitPrice")}</label>
                    <InputNumber
                        min={0}
                        step={0.01}
                        precision={2}
                        value={line.unitPrice === "" ? null : line.unitPrice}
                        placeholder="0.00"
                        onChange={(value) => onChange({ ...line, unitPrice: value ?? "" })}
                        style={{ width: "100%" }}
                    />
                </div>

                <div className="quote-line-item__field quote-line-item__field--qty">
                    <label>{t("quote.form.quantity")}</label>
                    <InputNumber
                        min={0}
                        step={0.5}
                        value={line.quantity === "" ? null : line.quantity}
                        onChange={(value) => onChange({ ...line, quantity: value ?? "" })}
                        style={{ width: "100%" }}
                    />
                </div>

                <div className="quote-line-item__field quote-line-item__field--subtotal">
                    <label>{t("quote.form.subtotal")}</label>
                    <div className="quote-line-item__subtotal">{formatMoney(subtotal, currency)}</div>
                </div>
            </div>

            <div className="quote-line-item__note-row">
                <div className="quote-line-item__field quote-line-item__field--note">
                    <label>{t("quote.form.note")}</label>
                    <Input
                        value={line.note}
                        placeholder={t("quote.form.notePlaceholder")}
                        onChange={(event) => onChange({ ...line, note: event.target.value })}
                    />
                </div>

                {canRemove && (
                    <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        className="quote-line-item__remove"
                        onClick={onRemove}
                        aria-label={t("quote.form.removeLine")}
                    />
                )}
            </div>

            <div className="quote-line-item__formula" aria-hidden="true">
                {formatMoney(line.unitPrice || 0, currency)} × {formatQuantity(line.quantity)} ={" "}
                {formatMoney(subtotal, currency)}
            </div>
        </div>
    );
}

export default QuoteLineItem;
